import React from "react";
import { Scale, Phone, MapPin, Clock } from "lucide-react";
import { firm, navLinks } from "../mock/mock";

const Footer = () => {
  return (
    <footer className="bg-[#0f1830] text-slate-300">
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="flex items-center justify-center w-10 h-10 rounded-md bg-[#c8a15a] text-[#14213d]">
                <Scale size={22} />
              </span>
              <div>
                <div className="font-display text-lg font-bold text-white">{firm.name}</div>
                <div className="text-xs uppercase tracking-[0.2em] text-[#c8a15a]">{firm.title}</div>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-slate-400 max-w-xs">
              {firm.tagline}. Serving Montgomery County and the surrounding
              communities.
            </p>
          </div>

          <div>
            <h4 className="font-display text-white font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {navLinks.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-sm hover:text-[#c8a15a] transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-white font-bold mb-4">Office</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#c8a15a] shrink-0 mt-0.5" />
                <span>{firm.address}, {firm.city}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-[#c8a15a] shrink-0" />
                <a href={firm.phoneHref} className="hover:text-[#c8a15a]">{firm.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <Clock size={18} className="text-[#c8a15a] shrink-0 mt-0.5" />
                <span>{firm.hours}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <span>© {new Date().getFullYear()} {firm.name}, {firm.title}. All rights reserved.</span>
          <span>Crawfordsville, Indiana</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
